export const comments_3899725 = {"data":{"data":[],"links":{}}}